import styled from "styled-components";
import { Text } from "./Text";
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'


const OportunityCardContainer = styled.div`
    width: 80%;
    height: 500px;
    background-color: rgba(61, 118, 153, 0.7);
    /* display: grid; */
    display: none;
    
    row-gap: 1em;
    border-radius: 20px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
    margin-top: -42em;
    text-align: center;
    word-wrap: break-word;
    white-space: normal;
    padding: 50px 30px 40px 30px;

    @media only screen and ${devices.mobileM} {
        width: 375px;
        /* display: none; */
        
    }
    @media only screen and ${devices.mobileL} {
        width: 420px;
        /* display: contents; */
        
    }
    @media only screen and ${devices.tablet} {
        width: 638px;
        /* display: contents; */
    }
    @media only screen and ${devices.laptop}{
        width: 80%;
        display: grid;

    }
    @media only screen and ${devices.laptopL}{
        width: 1400px;
        display: grid;

    }

`
// const Text2 = styled.p`
//     font-family: ${props => props.fontFamily};
//     font-size: ${props => props.fontSize};
//     color: ${props => props.color};
//     text-align: ${props => props.textAlign};
//     word-break: keep-all;
//     word-wrap: break-word;
//     /* display: none; */
//     @media only screen and ${devices.laptop}{
//         /* display: contents; */
//     }
//     @media only screen and ${devices.tablet} {
//         /* display: contents; */
//     }
// `
export const OportunityCard = (props)=>{
    return(
        <OportunityCardContainer>
            <Text 
                text={props.sar}
                fontFamily='Montserrat-Bold' 
                fontSize='20px'
                color='whitesmoke'/>
            <Text
                text={props.title}
                fontFamily='Montserrat-Regular' 
                fontSize='24px'
                color='whitesmoke'/>
            <Text 
                text={props.message}
                fontFamily='Damion-Regular' 
                fontSize='100px'
                color='whitesmoke'/>
            <Text 
                text={props.description}
                fontFamily='Montserrat-Bold' 
                fontSize='24px'
                color='whitesmoke'/>
        </OportunityCardContainer>
    )
}